import "./App.css";
import Home from "./screens/home";

function App() {
  return (
    <div className="App">
      <Home />
    </div>
  );
}

export default App;
